export const work = [
  {
    id: 1,
    title: "My Portfolio",
    description:
      "This project was built on the React JS, tailwind css, styledComponent and complete website hosted using vercel.",
    img: "https://sv1.picz.in.th/images/2022/02/19/r12JrQ.png",
    img2: "https://sv1.picz.in.th/images/2022/02/19/r12FyW.png",

    tags: ["react", "tailwaindcss", "vercel", "styledcomponent"],

    demo: "/",
    github: "https://github.com/s5935512064/react_resume",
    youtube: "/",
  },
  {
    id: 7,
    title: "Smooth Street",
    description:
      "Smooth Street build using VueJS. with quasar framework using Strapi to create API.",
    img: "https://sv1.picz.in.th/images/2022/02/22/rgkoFl.png",
    img2: "https://sv1.picz.in.th/images/2022/02/22/rgkgFz.png",

    tags: ["vue.js", "quasar", "strapi"],

    demo: "",
    github: "",
    youtube: "",
  },
  {
    id: 6,
    title: "CMS True Dragon",
    description:
      "My freelance job with DOPE company, The website build in VueJS, with content management system using quasar framework.",
    img: "https://sv1.picz.in.th/images/2022/02/22/rghtWe.png",
    img2: "https://sv1.picz.in.th/images/2022/02/22/rghwKl.png",

    tags: ["vue.js", "quasar", "strapi", "postman"],

    demo: "https://red-dragon-87c8f.web.app/#/createcampaign",
    github: "",
    youtube: "",
  },
  {
    id: 2,
    title: "Internship @PhuketSoftGroup",
    description:
      "Internship Project using Angular, responsive sites with Bootstrap and using firebase realtime database.",
    img: "https://sv1.picz.in.th/images/2022/02/19/r1P6qZ.png",
    img2: "https://sv1.picz.in.th/images/2022/02/19/r1PuBu.png",

    tags: ["angular", "bootstrap", "firebase"],

    demo: "",
    github: "",
    youtube: "https://www.youtube.com/watch?v=d3fZN7TRUs8&t=2s",
  },
  {
    id: 3,
    title: "PSU Care COVID-19 MiniProject",
    description:
      "Final assignment build on NextJS, responsive sites with Bootstrap and using firebase realtime database.",
    img: "https://sv1.picz.in.th/images/2022/02/19/r1Dj5J.png",
    img2: " https://miro.medium.com/max/875/1*4kWFEjXH6C46hsuRIgepCA.png",

    tags: ["next.js", "firebase", "vercel"],

    demo: "https://psu-care-project.vercel.app/product",
    github: "https://github.com/s5935512064/Next_Project.git",
    youtube: "https://youtu.be/SIHoCySCTRE",
  },
  {
    id: 4,
    title: "สร้าง App ด้วย [React-Native]",
    description: "A todo app was built on react native applications using expo",
    img: "https://miro.medium.com/max/591/1*7I1jC9yT07PPuRBKwSmptA.png",
    img2: "",

    tags: ["react", "native", "expo"],

    demo: "",
    github: "",
    youtube: "",
  },
  {
    id: 5,
    title: "PSU Activity Project Management System",
    description:
      "This Project was built VueJS, responsive sites with quasar framework, and using firebase services.",
    img: "https://sv1.picz.in.th/images/2022/02/22/rg1MII.png",
    img2: "https://sv1.picz.in.th/images/2022/02/22/rg1IuZ.png",

    tags: ["vue.js", "quasar", "firebase"],

    demo: "https://psu-activity.firebaseapp.com/#/calendar",
    github: "https://github.com/s5935512064/Activities_System",
    youtube: "https://www.youtube.com/watch?v=9AfSlZu9hTY&t=1072s",
  },
];
